<div class="show_filters_button" role="show_filters">
  {{ __('filters.title') }}
</div>
